"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AddressAppWrapper = require("./AddressAppWrapper");
var _forms = require("./forms");
var _jsxRuntime = require("react/jsx-runtime");
const DeliveryAddressForm = props => {
  const {
    appConfiguration,
    useAnonymousCustomer,
    customerId
  } = props;
  if (!appConfiguration.processContext) {
    appConfiguration.processContext = useAnonymousCustomer ? 'Checkout' : 'Delivery';
  }
  if (appConfiguration.customerId == null || typeof appConfiguration.customerId === 'undefined') {
    appConfiguration.customerId = customerId;
  }
  if (!appConfiguration.useAnonymousCustomer) {
    appConfiguration.useAnonymousCustomer = useAnonymousCustomer;
  }
  const SectionComponent = useAnonymousCustomer ? _forms.AnonymousAddressForm : _forms.AddressFormInternal;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressAppWrapper.AddressAppWrapper, {
    configuration: appConfiguration,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SectionComponent, {
      ...props
    })
  });
};
var _default = exports.default = DeliveryAddressForm;
//# sourceMappingURL=DeliveryAddressForm.js.map